import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import logo192 from '../assets/logo192.png';

const Layout = ({ isLoggedIn, onLogout }) => {
  return (
    <div className="min-h-screen bg-[#0E0E12] text-white flex flex-col font-sans overflow-x-hidden w-full relative selection:bg-[#FF7A00] selection:text-white">
      {/* Background Subtle Ambient Glows */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        <div className="absolute -top-40 left-1/4 w-[500px] h-[500px] bg-[#FF5E0E]/5 rounded-full blur-[140px]" />
        <div className="absolute top-1/3 -right-40 w-[600px] h-[600px] bg-[#FFB800]/5 rounded-full blur-[160px]" />
        <div className="absolute bottom-0 left-1/3 w-[700px] h-[500px] bg-[#FF5E0E]/4 rounded-full blur-[180px]" />
      </div>

      {/* Top Navbar */}
      <Navbar isLoggedIn={isLoggedIn} onLogout={onLogout} />

      {/* Main Content Area */}
      <main className="flex-1 w-full max-w-[1700px] mx-auto px-3 sm:px-6 lg:px-8 py-4 sm:py-6">
        <Outlet />
      </main>

      {/* Clean Footer */}
      <footer className="w-full border-t border-[#1F1F27] bg-[#0A0A0D]/80 backdrop-blur-md py-6 px-4 sm:px-8 mt-auto">
        <div className="max-w-[1700px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-500">
          <div className="flex items-center gap-2">
            <img src={logo192} alt="Logo" className="w-5 h-5 object-contain" />
            <span className="font-heading font-black text-sm tracking-wider text-white uppercase">
              KARNO<span className="text-[#FF7A00]">GAMES</span>
            </span>
            <span className="text-gray-600">|</span>
            <span>Next Generation Web Gaming Platform</span>
          </div>
          <span>© 2026 KarnoGames. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
};

export default Layout;